import type { NavigateFunction } from 'react-router-dom';
import axiosInstance from './axios';

/**
 * Mở công việc dm_taskid trên trang FBS (giống "Đến FBS" từ văn bản đi).
 * Fallback: /task-project/:id nếu không lấy được project_id.
 */
export async function navigateToDmTaskidFbs(
  navigate: NavigateFunction,
  taskId: number
): Promise<void> {
  try {
    const res = await axiosInstance.get(`/dm-taskids/${taskId}`);
    const d = res.data?.data;
    if (res.data?.code === 0 && d?.project_id != null) {
      navigate('/task-project-fbs', {
        state: { navigateToTaskId: taskId, navigateToProjectId: d.project_id },
      });
      return;
    }
  } catch {
    /* ignore */
  }
  navigate(`/task-project/${taskId}`);
}
